import { useQuery } from '@apollo/client'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { queries } from '../../graphql'
import { Loading } from '../../components'

export function DonorProfileRedirect() {
  const { '*': splat } = useParams()
  const { state } = useLocation()
  const { data: { me } = {}, loading } = useQuery(queries.user.me)

  if (loading) return <Loading />

  const firstFundId = me?.funds?.find((f) => !f.name?.startsWith('charity-') && !f.closed)?.id
  if (!firstFundId) return <Navigate to="/" replace />

  const subPath = splat ? `/${splat}` : '/user-details'
  return <Navigate to={`/profile/${firstFundId}${subPath}`} state={state} replace />
}
